export const GOOGLE_MAPS_API_KEY = 'AIzaSyB49FE3ZDC76P2F1zeXdrNaSpAQSSdi8Qs';